import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Home from '@/components/Home'
import PublicUpload from '@/components/PublicUpload'
import Files from '@/components/Files'
import Users from '@/components/Users'
import ProjectGroups from '@/components/ProjectGroups'
import TmpUpload from '@/components/TmpUpload'
import Profile from '@/components/Profile'
import Password from '@/components/Password'
import Logout from '@/components/Logout'
import Download from '@/components/Download'
import Settings from '@/components/Settings'

Vue.use(Router);

import {globalStore} from '../main.js'

const checkAuthState = function (to, from, next) {
    if (!globalStore.authed) {
        next('/');
        return;
    }

    next();
};

const checkInitialAuthState = function (to, from, next) {
    if (globalStore.authed) {
        next('/home');
        return;
    }

    next();
};

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Login',
            component: Login,
            beforeEnter: checkInitialAuthState
        },
        {
            path: '/home',
            name: 'Home',
            component: Home,
            beforeEnter: checkAuthState
        },
        {
            path: '/upload/:token',
            name: 'PublicUpload',
            component: PublicUpload
        },
        {
            path: '/files',
            name: 'Files',
            component: Files,
            beforeEnter: checkAuthState
        },
        {
            path: '/users',
            name: 'Users',
            component: Users,
            beforeEnter: checkAuthState
        },
        {
            path: '/projectGroups',
            name: 'ProjectGroups',
            component: ProjectGroups,
            beforeEnter: checkAuthState
        },
        {
            path: '/tmpUpload',
            name: 'TmpUpload',
            component: TmpUpload,
            beforeEnter: checkAuthState
        },
        {
            path: '/profile',
            name: 'Profile',
            component: Profile,
            beforeEnter: checkAuthState
        },
        {
            path: '/password',
            redirect: {
                name: 'Login'
            }
        },
        {
            path: '/password/:token',
            name: 'Password',
            component: Password
        },
        {
            path: '/logout',
            name: 'Logout',
            component: Logout
        },
        {
            path: '/download/:token',
            name: 'Download',
            component: Download
        },
        {
            path: '/settings',
            name: 'Settings',
            component: Settings,
            beforeEnter: checkAuthState
        },
        {
            path: '*',
            name: 'CatchWrongRoutes',
            redirect: {
                name: 'Home'
            }
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js